var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"wrap",attrs:{"cols":"12"}},[_c('div',{ref:"map",staticClass:"map"}),_c('v-overlay',{attrs:{"absolute":"","value":_vm.loading,"opacity":0.3,"z-index":4}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }